import { useEffect } from "react";

/** Inject a JSON-LD <script> into <head> for the current page, with cleanup. */
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, data]);
}
